import React from 'react';
import { Row, Col } from 'reactstrap';
import { HashLink as Link } from 'react-router-hash-link';

function IntroductionSection() {
    return (
        <section id="introduction">
            <Row>
                <Col>
                    <h1>Introduction</h1>
                    <p>
                        StepStone UK has created a <b>Federated Search API</b> to enable our clients easy and fast access to our
                        Candidates database (CVDB) through 3<sup>rd</sup> parties.
                    </p>
                    <p>
                        The Federated Search API consists of the <b>following endpoints</b> that mimic our CVDB features:
                    </p>
                    <ul className="list-group">
                        <li className="list-group-item border-0 p-0">
                            <Link to="#search">Search</Link>
                        </li>
                        <li className="list-group-item border-0 p-0">
                            <Link to="#endpointscandidatedetails">Candidate</Link>
                        </li>
                        <li className="list-group-item border-0 p-0">
                            <Link to="#cvdownload">CV</Link>
                        </li>
                        <li className="list-group-item border-0 p-0">
                            <Link to="#dictionary">Dictionary</Link>
                        </li>
                        <li className="list-group-item border-0 p-0">
                            <Link to="#applications">Applications endpoint</Link>
                        </li>
                        <li className="list-group-item border-0 p-0">
                            <Link to="#applicationssummaryendpoint">Application summary endpoint</Link>
                        </li>
                    </ul>
                </Col>
            </Row>
        </section>
    )
}

export default IntroductionSection
